import { gql } from 'apollo-boost';

export const SIMPLE_AUTH_TOKEN_QUERY = gql`
    query simpleAuth($token: String!, $environment: String!) {
        simpleAuth(token: $token, environment: $environment) {
            success
        }
    }
`;
